import { useTheme } from '@emotion/react'
import styled from '@emotion/styled'

import { BaseCell, PushCell } from '@cash-design-system/react'
import { InstrumentSelectionBlockerInstrumentOption } from '@cash-web/protos/squareup/franklin/blockers/instrument_selection_blocker.pb'
import { CashInstrumentType } from '@cash-web/protos/squareup/franklin/cash_instrument_type.pb'
import { InstrumentLogo } from '@cash-web/shared/ui-instrument-logo'
import logger from '@cash-web/shared/util-logger'
import { IconWithOutline } from '@cash-web/shared-feature-common'
import { unicodeToEmojiSvg } from '@cash-web/shared-ui-emojis'

const Emoji = styled.img`
  width: 1.5rem;
  height: 1.5rem;
`

const InstrumentOptionAvatar = ({ option }: { option: InstrumentSelectionBlockerInstrumentOption }) => {
  const { darkMode } = useTheme()

  if (option.app_icon) {
    logger.error(new Error('InstrumentSelectionBlocker: app_icon is unimplemented'))
  } else if (option.balance_icon) {
    return <InstrumentLogo type={CashInstrumentType.CASH_BALANCE} size="medium" />
  } else if (option.bank_icon) {
    logger.error(new Error('InstrumentSelectionBlocker: bank_icon is unimplemented'))
  } else if (option.card_icon) {
    logger.error(new Error('InstrumentSelectionBlocker: card_icon is unimplemented'))
  } else if (option.digital_wallet_icon) {
    logger.error(new Error('InstrumentSelectionBlocker: digital_wallet_icon is unimplemented'))
  } else if (option.emoji_icon?.code) {
    return (
      <IconWithOutline
        icon={
          <Emoji
            src={unicodeToEmojiSvg({
              unicode: option.emoji_icon.code,
              size: 24,
              darkMode,
            })}
          />
        }
      />
    )
  }

  logger.error(new Error('InstrumentSelectionBlocker: no option icon found'))

  return null
}

export const InstrumentOption = ({
  option,
  onClick,
  variant,
}: {
  option: InstrumentSelectionBlockerInstrumentOption
  onClick?: () => void
  variant: 'selection' | 'list'
}) => {
  const Avatar = <InstrumentOptionAvatar option={option} />

  const isDisabled = Boolean(option.disabled_state)
  const selectedTitle = isDisabled
    ? option.disabled_state?.selected_title
    : option.enabled_state?.select_instrument_action?.selected_title
  const label = (variant === 'selection' ? selectedTitle : option.list_title) ?? ''

  const selectedBody = isDisabled
    ? option.disabled_state?.selected_subtitle_primary
    : option.enabled_state?.select_instrument_action?.selected_subtitle_primary
  const body = variant === 'selection' ? selectedBody : option.list_subtitle_primary

  if (onClick && !isDisabled) {
    return (
      <PushCell
        label={label}
        onClick={e => {
          e.preventDefault()
          onClick()
        }}
        cellProps={{
          asset: {
            avatar: Avatar,
          },
          body,
        }}
      />
    )
  }

  return (
    <BaseCell
      asset={{
        avatar: Avatar,
      }}
      label={label}
      body={body}
      disabled={isDisabled}
    />
  )
}
